__turbopack_context__.v({
  "active": "outcome-module-sass-module__tQwZsq__active",
  "decreased": "outcome-module-sass-module__tQwZsq__decreased",
  "disabled": "outcome-module-sass-module__tQwZsq__disabled",
  "horizontal": "outcome-module-sass-module__tQwZsq__horizontal",
  "increased": "outcome-module-sass-module__tQwZsq__increased",
  "mainMarket": "outcome-module-sass-module__tQwZsq__mainMarket",
  "outcomeItem": "outcome-module-sass-module__tQwZsq__outcomeItem",
  "outcomeItemValue": "outcome-module-sass-module__tQwZsq__outcomeItemValue",
  "resultsOutcomeItemValue": "outcome-module-sass-module__tQwZsq__resultsOutcomeItemValue",
});
